import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "19",
  height: "19",
  fill: "none",
  viewBox: "0 0 19 19"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", { "clip-path": "url(#a)" }, [
      _createElementVNode("path", {
        fill: "currentColor",
        d: "M15.042 0H3.958A3.963 3.963 0 0 0 0 3.958v11.084A3.963 3.963 0 0 0 3.958 19h9.22a3.8 3.8 0 0 0 2.697-1.117l2.008-2.008A3.84 3.84 0 0 0 19 13.178v-9.22A3.963 3.963 0 0 0 15.042 0M1.583 15.042V3.958a2.38 2.38 0 0 1 2.375-2.375h11.084a2.38 2.38 0 0 1 2.375 2.375v7.917H14.25a2.38 2.38 0 0 0-2.375 2.375v3.167H3.958a2.38 2.38 0 0 1-2.375-2.375m13.173 1.722a2.2 2.2 0 0 1-1.298.634V14.25c0-.437.356-.792.792-.792h3.148a2.25 2.25 0 0 1-.635 1.298zM3.958 5.146a1.188 1.188 0 1 1 2.376 0 1.188 1.188 0 0 1-2.376 0M6.333 9.5a1.188 1.188 0 1 1-2.376 0 1.188 1.188 0 0 1 2.376 0m0 4.354a1.188 1.188 0 1 1-2.376 0 1.188 1.188 0 0 1 2.376 0"
      })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "a" }, [
        _createElementVNode("path", {
          fill: "#fff",
          d: "M0 0h19v19H0z"
        })
      ])
    ], -1)
  ]))]))
}
export default { render: render }